import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { TimeOfDay } from './time-of-day.js';

export class ScheduleTimeSpan extends DataModel {
  static readonly TYPE_ID: string = '118d779862b740d8b752515417be7991';

  constructor(
        public readonly from: TimeOfDay,
        public readonly to: TimeOfDay,
  ) {
    super();
  }

  get durationInMinutes(): number {
    return this.to.inMinutes - this.from.inMinutes;
  }

  get $typeId() {
    return ScheduleTimeSpan.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ScheduleTimeSpan {
    return new ScheduleTimeSpan(
        context.fromData<TimeOfDay>(MapUtils.getRaw(map, 'from') as SerializedData),
        context.fromData<TimeOfDay>(MapUtils.getRaw(map, 'to') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'from': context.toData(this.from),
      'to': context.toData(this.to),
    };
  }

  clone(): this {
    return new ScheduleTimeSpan(
        this.from.clone(),
        this.to.clone(),
    ) as this;
  }

  isSame(other: ScheduleTimeSpan): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.from, this.from) &&
            isSameData(other.to, this.to);
  }
}

export class ScheduleTimeSpanBuilder extends DataModelBuilder<ScheduleTimeSpan> {
  build(context: SerializationContext, map: SerializedData): ScheduleTimeSpan {
    return ScheduleTimeSpan.fromMap(context, map);
  }
}
